import React from 'react';
import { Modal } from 'react-bootstrap';
import { Button } from '@spark/ui-components/components/Button';
import TanStackTable from '@spark/ui-components/components/TanStackTable/TanStackTable';
import FilterPanel from '@spark/ui-components/components/FilterPanel';
import { useRotaSelection } from '../hooks/useRotaSelection';
import { getRotaColumns } from '../config/rotaColumns';
import { rotaFilterConfig } from '../config/rotaFilterConfig';

const RotaSelectionModal = ({ show, onHide, onSelect }) => {
  const {
    rotas,
    loading,
    paginaAtual,
    quantidadePorPagina,
    totalRegistros,
    handleFiltrosChange,
    handlePaginationChange,
  } = useRotaSelection(show);

  const handleSelectRota = (rota) => {
    const codigo = rota.CodigoIntegracao ?? rota.codigoIntegracao ?? rota.Codigo ?? rota.codigo ?? rota.Id ?? rota.id ?? '';
    const descricao = rota.Descricao ?? rota.descricao ?? String(codigo || '');
    const label = descricao && codigo && String(descricao) !== String(codigo)
      ? `${descricao} (${codigo})`
      : descricao || String(codigo || '');

    onSelect({
      value: String(codigo),
      label,
      data: rota
    });
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} animation={false} size="xl" backdrop="static">

      <Modal.Header closeButton>
        <Modal.Title>Selecionar Rota</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <FilterPanel
          filters={rotaFilterConfig}
          onApply={handleFiltrosChange}
          title="Filtros de Busca"
          loading={loading}
          defaultCollapsed={false}
        />

        <TanStackTable
          key={`rota-selection-${paginaAtual}-${quantidadePorPagina}`}
          columns={getRotaColumns(handleSelectRota)}
          data={rotas}
          loading={loading}
          withPagination={true}
          pageSizeOptions={[5, 10, 25, 50]}
          enableRowColors={true}
          className="mt-3"
          manualPagination={true}
          totalItems={totalRegistros}
          controlledPagination={{
            pageIndex: Math.max(0, (paginaAtual || 1) - 1),
            pageSize: quantidadePorPagina || 10,
          }}
          onPaginationChange={handlePaginationChange}
        />
      </Modal.Body>

      <Modal.Footer>
        <div className="d-flex justify-content-between w-100">
          <div className="text-muted">
            {totalRegistros > 0 && (
              <span>
                Exibindo {rotas.length} de {totalRegistros} rota(s)
              </span>
            )}
          </div>
          <div>
            <Button variant="secondary" onClick={onHide}>
              Cancelar
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default RotaSelectionModal;
